import React from "react";

import { useIntl } from "../../../../../shared/core/i18n/use-intl";
import type { Mandate } from "../../../../../shared/domains/mandates/mandate";
import { DETAIL_MANDATE_MODAL_ID } from "../../../../core/modal/modal-id";
import { RoundedModalContainer } from "../../../common/modal/rounded-modal-container";
import { Container, Header, Label, Result, Section, SectionContent, SectionTitle, Status, Title } from "../../ui/style";
import { MandateStatusPill } from "./mandate-status-pill";

export interface DetailMandateModalProps {
  mandate: Mandate;
}

export const DetailMandateModal = ({ mandate }: DetailMandateModalProps) => {
  const { formatDate, formatMessage } = useIntl();

  return (
    <RoundedModalContainer closeButton={true} id={DETAIL_MANDATE_MODAL_ID}>
      <Container>
        <Header>
          <Title>{formatMessage("mandates.details.to") + " " + mandate?.creditorName}</Title>
          <Status>
            <MandateStatusPill status={mandate?.status} />
          </Status>
        </Header>

        <Section>
          <SectionTitle>{formatMessage("mandates.details.mandateDetails")}</SectionTitle>
          {mandate?.reference && <Field label={formatMessage("mandates.details.reference")}>{mandate.reference}</Field>}
          {mandate?.id && <Field label={formatMessage("mandates.details.id")}>{mandate.id}</Field>}
          {mandate?.signatureDate && (
            <Field label={formatMessage("mandates.details.signatureDate")}>
              {formatDate(mandate.signatureDate, { year: "numeric", month: "long", day: "numeric" })}
            </Field>
          )}
        </Section>
        <Section>
          <SectionTitle>{formatMessage("mandates.details.creditorDetails")}</SectionTitle>
          {mandate?.creditorRef && (
            <Field label={formatMessage("mandates.details.creditorRef")}>{mandate.creditorRef}</Field>
          )}
        </Section>
        {mandate?.originalMandate && (
          <Section>
            <SectionTitle>{formatMessage("mandates.details.accountInformation")}</SectionTitle>
            {mandate?.originalMandate?.debtorIban && (
              <Field label={formatMessage("mandates.details.accountIban")}>{mandate.originalMandate.debtorIban}</Field>
            )}
            {mandate?.originalMandate?.debtorBic && (
              <Field label={formatMessage("mandates.details.accountBic")}>{mandate.originalMandate.debtorBic}</Field>
            )}
          </Section>
        )}
      </Container>
    </RoundedModalContainer>
  );
};
const Field = ({ label, children, className }: { label: string; children: React.ReactNode; className?: string }) => (
  <SectionContent className={className}>
    <Label>{label}</Label>
    <Result>{children}</Result>
  </SectionContent>
);
